import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "16",
  r: "1",
  fill: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 3.5C6.201 3.5 1.5 8.201 1.5 14c0 .168.004.334.012.5M12 3.5c5.799 0 10.5 4.701 10.5 10.5 0 .168-.004.334-.012.5M12 3.5v3m-10.488 8a10.434 10.434 0 0 0 1.542 5h17.892a10.434 10.434 0 0 0 1.542-5m-20.976 0H4.5m17.988 0H19.5m-14-5L3.638 7.648M18.5 9.5l1.873-1.837M12 16l3-9",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }